'use client'

import { TextLink } from '@/General/TextLink'
import { useSearchParams } from 'next/navigation'

export const YouthEventSwitch = () => {
  const searchParams = useSearchParams()
  const hideYouth = searchParams.get('hideYouth') === 'true'

  return (
    <div className="flex justify-end mb-4">
      <TextLink
        href={
          hideYouth
            ? '/magic-conventions/magifest/schedule/'
            : '/magic-conventions/magifest/schedule/?hideYouth=true'
        }
      >
        {hideYouth ? 'Show youth events' : 'Hide youth events'}
      </TextLink>
    </div>
  )
}
